import React from 'react';
import { Shield } from 'lucide-react';

export default function PrivacyPolicy() {
    return (
        <div className="animate-fade-in" style={{
            maxWidth: '800px',
            margin: '0 auto',
            padding: '40px 20px',
            paddingBottom: '100px',
            color: 'var(--text-main)'
        }}>
            <div className="glass-panel" style={{ padding: '40px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '30px' }}>
                    {/* Mascot */}
                    <img
                        src="/images/mascots/SparkSecret.png"
                        alt="SparkSecret Mascot"
                        style={{ height: '60px', width: 'auto', objectFit: 'contain' }}
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'block';
                        }}
                    />
                    {/* Fallback Icon */}
                    <div style={{ display: 'none' }}>
                        <Shield size={32} color="#8b5cf6" />
                    </div>
                    <h1 style={{ margin: 0, fontSize: '2rem' }}>Privacy Policy</h1>
                </div>

                <div style={{ opacity: 0.8, lineHeight: '1.6' }}>
                    <p><strong>Last Updated:</strong> December 2025</p>

                    <h3>1. Introduction</h3>
                    <p>
                        Welcome to "Spark Inspo" ("we," "our," or "us"). We are committed to protecting your personal information and your right to privacy. If you have any questions or concerns about this privacy notice or our practices with regards to your personal information, please contact us.
                    </p>

                    <h3>2. Information We Collect</h3>
                    <p>
                        We collect personal information that you voluntarily provide to us when you register on the website, express an interest in obtaining information about us or our products and services, when you participate in activities on the website (such as posting messages in our online forums or entering competitions, contests or giveaways) or otherwise when you contact us.
                    </p>
                    <ul>
                        <li>Personal Data: Name, email address, profile picture.</li>
                        <li>Usage Data: Information about how you use our website.</li>
                    </ul>

                    <h3>3. How We Use Your Information</h3>
                    <p>
                        We use personal information collected via our website for a variety of business purposes described below. We process your personal information for these purposes in reliance on our legitimate business interests, in order to enter into or perform a contract with you, with your consent, and/or for compliance with our legal obligations.
                    </p>
                    <ul>
                        <li>To facilitate account creation and logon process.</li>
                        <li>To send you marketing and promotional communications.</li>
                        <li>To fulfill and manage your orders.</li>
                        <li>To request feedback.</li>
                    </ul>

                    <h3>4. Cookies and Web Beacons</h3>
                    <p>
                        Like any other website, we use 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.
                    </p>
                    <p>
                        <strong>Google DoubleClick DART Cookie:</strong> Google is one of a third-party vendor on our site. It also uses cookies, known as DART cookies, to serve ads to our site visitors based upon their visit to www.website.com and other sites on the internet. However, visitors may choose to decline the use of DART cookies by visiting the Google ad and content network Privacy Policy at the following URL – <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noreferrer" style={{ color: '#8b5cf6' }}>https://policies.google.com/technologies/ads</a>
                    </p>

                    <h3>5. AI-Powered Features</h3>
                    <p>
                        Our platform uses <strong>Google Gemini AI</strong> to generate creative prompts and challenges. When you interact with AI-powered features (Daily Challenges and Muse AI), your prompts or requests may be processed by Google's AI services.
                    </p>
                    <ul>
                        <li><strong>What we send:</strong> Only the prompt text you submit or the context needed to generate creative suggestions.</li>
                        <li><strong>What we don't send:</strong> Your personal information, account details, email address, or any content you create in response to prompts.</li>
                        <li><strong>Third-party processing:</strong> Google processes these requests according to their own privacy policy. View Google's AI privacy practices at <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" style={{ color: '#8b5cf6' }}>https://policies.google.com/privacy</a></li>
                        <li><strong>Fallback:</strong> If AI services are unavailable, we automatically use curated static content instead.</li>
                    </ul>
                    <p>
                        <em>Important:</em> AI-generated content is provided as creative inspiration only. We do not guarantee accuracy, appropriateness, or suitability for any particular purpose.
                    </p>

                    <h3>6. Third-Party Privacy Policies</h3>
                    <p>
                        Our Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.
                    </p>

                    <h3>7. Contact Us</h3>
                    <p>
                        If you have any questions about this Privacy Policy, please contact us.
                    </p>
                </div>
            </div>
        </div>
    );
}
